import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import {updateStudent} from "../TeachersComponent/actions";
import REST from '../Shared/REST';
import '../assets/custom.css';
import Helpers from "../Shared/Helpers";
import {BUCKET_URL, MAIN} from "../Shared/Consts";
import queryString from 'query-string';
import FooterComponent from "../Shared/Footer";
import HeaderComponent from "../Shared/Header";

import ico_correct from '../assets/images/correct.png';
import ico_wrong from '../assets/images/wrong.png';
import {updateStudentAppsStatus} from "../StudentsComponent/actions";
import {connect} from "react-redux";


class PN1On1Teacher extends Component {

    constructor(props) {
        super(props);
        this.state = {
            testId: null,
            userId:null,
            paused: true,
            started: false,
            finished: false,
            saved: false,
            timer:null,
            websocket: null,
            bestScores: null,
            startLevel: 0,
            endLevel: 0,
            startProgress: 0,
            endProgress: 0,
            rejectedReason: '',
            recording: false,
            imageSrc: "",
            pnPicture: null,
            studentJoined: false,
            currentWord:"",
            currentIndex:0,
            pnPictures:[],
            sessionData: {
                testId:null,
                gradingTime: 60,
                numberCorrect: 0,
                numberIncorrect: 0,
                numberSkipped:20,
                endLevel:1,
                startLevel:1,
                endProgress:1,
                pnPictures:[],
                assessmentType: 1,
                startProgress: 1,
                guid:require('uuid/v4')()
            }
        };

        this.handleStartPNManual = this.handleStartPNManual.bind(this);
        this.gradePNPicture = this.gradePNPicture.bind(this);
        this.submitPNSessionGrade = this.submitPNSessionGrade.bind(this);
        this.changeImage = this.changeImage.bind(this);
        this.pause = this.pause.bind(this);
        this.handleGoBack = this.handleGoBack.bind(this);
    }

    componentDidMount() {
        Helpers.authorize(this);
        const parsed = queryString.parse(this.props.location.search);
        this.setState({userId: parsed.userId});
    };

    componentWillUnmount(){
        clearInterval(this.state.timer);
    }

    wait = (ms) => {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    };

    submitPNSessionGrade = async()=>{
        this.state.sessionData.testId = this.state.testId;
        console.log("Submitting session data: ",this.state.sessionData);
        await REST.gradePNSession(this.state.sessionData);
        alert("The 1-1 computer task has been successfully and saved.")
        this.setState({
            saved: true,
        });
    };

    rotatePictures = async (pnPictures,websocket) => {
        let time = 3.0;
        console.log("Starting assessment interval.",pnPictures);
        let timer = setInterval(() => {
            let i = this.state.currentIndex;
            if(!this.state.paused) {
                if (this.state.pnPicture
                    && this.state.pnPicture.pn_assessments_picture.grade === 0) {
                    this.gradePNPicture(2);
                }
                if (i < pnPictures.length) {
                    let ap = pnPictures[i];
                    this.setState({
                        pnPicture:ap,
                        imageSrc: ap.url,
                        currentWord:ap.word
                    });
                    websocket.send(JSON.stringify({url: ap.url,currentIndex:i}));
                }
                else {
                    clearInterval(timer);
                    this.setState({
                        imageSrc: "",
                        currentWord:"",
                        currentIndex:-1,
                        finished: true
                    });
                    websocket.send(JSON.stringify({url: "", currentIndex:-1}));
                    //this.submitPNSessionGrade();
                }
                this.setState({
                    currentIndex: this.state.currentIndex + 1
                });
            }
        },time*1000);

        this.setState({
            timer:timer
        });
    };

    handleStartPNManual = async (websocket) => {
        await REST.getPNManualSession(this.state.testId).then(res => {
            let manualPNSession = res.body;
            if (manualPNSession) {
                this.state.pnPictures = manualPNSession.pn_pictures;
                this.setState({
                    pnPictures:manualPNSession.pn_pictures,
                    saved: false
                });
                this.rotatePictures(manualPNSession.pn_pictures,websocket);
            } else {
                alert("An Invalid Assessment ID has been provided.");
            }

        }).catch(error => {
            alert("An Invalid Assessment ID has been provided.")
        });
    };

    openWebSocket = async() => {
        await this.setState({
            testId: null,
            paused: true,
            started: false,
            studentJoin: false,
            finished: false,
            saved: false
        });
        if (this.state.userId != null) {
            let authToken = localStorage.getItem('token');

            let data = {
                userId: this.state.userId,
                assessmentType: 1, //1-1 computer session
            };
            let pnAsst = await REST.createPN1On1Session(data);

            await this.setState({testId: pnAsst.body.id});

            const socket = new WebSocket(MAIN.API.START_PICTURENAMING_WEBSOCKET + "?token=" + authToken + "&testId=" + this.state.testId);

            socket.addEventListener('open', (event) => {
                this.setState({websocket: socket});
                this.handleStartPNManual(socket);
            });

            socket.addEventListener('message', (event) => {
                let studentMessage = JSON.parse(event.data);
                this.setState({studentJoined: studentMessage.status});
                console.log('Message from server ',);
            });

        } else {
            alert("Please enter the student username in order to start the session.");
        }
    };

    gradePNPicture(grade) {
        var oldGrade = this.state.pnPicture.pn_assessments_picture.grade;
        this.state.pnPicture.pn_assessments_picture.grade = grade;
        this.state.sessionData.pnPictures.push(this.state.pnPicture);
        if(oldGrade!==grade){
            if(oldGrade===1) {
                this.state.sessionData.numberCorrect = this.state.sessionData.numberCorrect - 1;
            }else if (oldGrade===2) {
                this.state.sessionData.numberIncorrect = this.state.sessionData.numberIncorrect - 1;
            }else if (oldGrade===0) {
                this.state.sessionData.numberSkipped = this.state.sessionData.numberSkipped - 1;
            }
            if(grade===1) {
                this.state.sessionData.numberCorrect = this.state.sessionData.numberCorrect + 1;
            }else if (grade===2) {
                this.state.sessionData.numberIncorrect = this.state.sessionData.numberIncorrect + 1;
            }else if (grade===0) {
                this.state.sessionData.numberSkipped = this.state.sessionData.numberSkipped + 1;
            }
        }
        this.forceUpdate();
    }

    pause(pause) {
        this.setState({paused: pause, started: true});
    }

    changeImage(index){
        let ap = this.state.pnPictures[index];
        this.setState({
            pnPicture:ap,
            imageSrc: ap.url,
            currentIndex:index,
            currentWord:ap.word
        });
        this.state.websocket.send(JSON.stringify({url: ap.url}));
        this.pause(true);
    }

    handleGoBack(){
        this.props.updateStudent(null);
        this.props.history.push("/teacher");
    }

    render() {

        let imageThumbnails = this.state.pnPictures.map((pnPic,index)=>{

            let gradeSrc = "";
            if(pnPic.pn_assessments_picture.grade === 1){
                gradeSrc = ico_correct;
            }else if(pnPic.pn_assessments_picture.grade === 2){
                gradeSrc = ico_wrong
            }

            return(<div key={index} style={{display:"inline-block",paddingTop:"20px",paddingLeft:"20px", paddingBottom:"20px",paddingRight:"20px"}}>
                <img style={{ position:"relative", top: "-10px", left: "0px", zIndex: 2}} src={gradeSrc} alt={""}/>
                <img style={{ position:"relative", top: "0px", left: "0px", zIndex: 1, cursor: "pointer"}} key={index} onClick={()=>this.changeImage(index)} src={pnPic.url} width="50" height="43" alt={pnPic.word}/>
            </div>)
        });

        return (
            <div>
                <HeaderComponent {...this.props}/>
                <div className={"section bgGrey"}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="col-lg-12 noPadding mobileCenter">
                                    <div className="col-sm-8"><h1>Picture Naming 1-1 Computer Task</h1></div>
                                    <div className="col-sm-4 tr">
                                        <a href={"https://docs.google.com/document/d/1b5QXeINPTbOQ5j74CVXieeCWXMf-xsX62pZkEjuNUdw"} className="handBtn" style={{ textDecoration: 'none', marginTop: -10 }} target="_blank"><span>Help Doc</span></a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <hr/>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="col-lg-12 solidBorder">
                                    <div className="col-lg-12">
                                        <div className="col-lg-6">
                                            <div className={"form-group"}>
                                                {this.state.testId || this.state.saved ? null:
                                                    <a onClick={this.openWebSocket} className="handBtn" style={{marginRight:0}}>
                                                        <span>New Task</span>
                                                    </a>
                                                }
                                            </div>
                                            {this.state.testId?
                                                <div>
                                                    <label>Task ID : #{this.state.testId}</label>
                                                    <br/>
                                                    {
                                                        this.state.saved?<div>Status: Session saved.</div>:
                                                        this.state.studentJoined?
                                                            this.state.started?
                                                                this.state.finished?
                                                                    <div>Status: Completed <br/> Press "Save" button to save this session.</div>:
                                                                        this.state.paused?<div>Status: Paused<br/> Press "Start" button when both of you are ready.</div>
                                                                            :<div>Status: In progress<br/> Press "Pause" button when you want to pause.</div>
                                                                :<div>Status: Student has joined this task session.<br/> Press "Start" button when both of you are ready.</div>
                                                                    :<div>Status: Waiting for student to join.<br/>
                                                                    (Ask student to join using Task ID # above)</div>
                                                    }
                                                    <br/>
                                                </div>:null
                                            }
                                            <div hidden={this.state.paused || !this.state.studentJoined || this.state.finished} className={"form-group"}>
                                            <a onClick={() => this.pause(true)} className="handBtn" style={{marginTop:10}}>
                                                <span>PAUSE</span>
                                            </a>
                                            </div>
                                            <div hidden={!this.state.paused || !this.state.studentJoined || this.state.saved} className={"form-group"}>
                                            <a  onClick={() => this.pause(false)} className="handBtn" style={{marginTop:10}}>
                                                <span>START</span>
                                            </a>
                                            </div>
                                            {this.state.saved?
                                                <div>
                                                    <div>
                                                        <a onClick={this.openWebSocket} className="handBtn" style={{marginRight:0}}>
                                                            <span>New Task</span>
                                                        </a>
                                                    </div>
                                                    <div style={{marginTop: 20}}>
                                                        <a onClick={this.handleGoBack} style={{marginRight:0}}>
                                                            To select another student,<br/>go to Student list.
                                                        </a>
                                                    </div>
                                                </div>:null
                                            }

                                        </div>
                                        <div className="col-lg-6">
                                            <div className="row"><h1 style={{fontSize: "18pt",textAlign:"center"}}>{this.state.currentWord}</h1></div>
                                            <div className={"row"}>
                                                <img height={256} className={this.state.imageSrc === "" ? "":"center-block"} hidden={this.state.imageSrc === ""} src={this.state.imageSrc} alt="PNPicture"/>
                                                <br/><br/>
                                            </div>
                                            <div hidden={this.state.imageSrc === ""} className="row text-center">
                                                <button className="btn2 btn-success" onClick={() => this.gradePNPicture(1)}>Correct</button>
                                                <button className="btn2 btn-danger" onClick={() => this.gradePNPicture(2)}>Incorrect</button>
                                                <button className="btn2 btn-info" onClick={() => this.gradePNPicture(0)}>Skip</button>
                                            </div>
                                            <div className="row">
                                                {imageThumbnails}
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 paddingTop">
                            <div className="divBottomRelative tr">
                                <a onClick={()=>this.props.history.goBack()} className="handBtn fl"><span>Exit</span></a>
                                {this.state.testId && this.state.studentJoined?
                                <a onClick={this.submitPNSessionGrade} className="handBtn"><span>Save</span></a>
                                :null}
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );

    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudent: async (student) => await dispatch(updateStudent(student)),
    };
};

const mapStateToProps = state => ({
    student: state.teacherReducer.student,
});

export default connect(mapStateToProps, bindActionToProps)(withRouter(PN1On1Teacher));



// WEBPACK FOOTER //
// ./src/TeachersComponent/PN1On1Teacher.js